import { render } from "./Modals.vue?vue&type=template&id=08d91d36&scoped=true"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"

import "./Modals.vue?vue&type=style&index=0&id=08d91d36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d91d36"]])

export default __exports__